type SsoEventName =
  | 'sso_login_started'
  | 'sso_callback_landed'
  | 'sso_exchange_ok'
  | 'sso_exchange_failed'
  | 'sso_login_ok'
  | 'sso_login_failed'
  | 'sso_challenge_ok'
  | 'sso_challenge_failed'
  | 'sso_logout_local'
  | 'sso_logout_idp_redirect'

export type SsoEventContext = {
  portal_id?: string
  provider_slug?: string
  attempt?: number
  [key: string]: unknown
}

/**
 * Best-effort RUM action — telemetry must never break the login flow, and the
 * RUM SDK is only initialized on prod (see useDataDog.ts).
 */
export const trackSsoEvent = (
  name: SsoEventName,
  context: SsoEventContext = {}
): void => {
  console.debug(`[sso] ${name}`, context)

  import('@datadog/browser-rum')
    .then(({ datadogRum }) => datadogRum.addAction(name, context))
    .catch(() => undefined)
}
